__turbopack_context__.v({
  "react-dadata": "dadata-module-scss-module__kjrolW__react-dadata",
  "react-dadata--highlighted": "dadata-module-scss-module__kjrolW__react-dadata--highlighted",
  "react-dadata__container": "dadata-module-scss-module__kjrolW__react-dadata__container",
  "react-dadata__suggestion": "dadata-module-scss-module__kjrolW__react-dadata__suggestion",
  "react-dadata__suggestion--current": "dadata-module-scss-module__kjrolW__react-dadata__suggestion--current",
  "react-dadata__suggestion--line-through": "dadata-module-scss-module__kjrolW__react-dadata__suggestion--line-through",
  "react-dadata__suggestion-note": "dadata-module-scss-module__kjrolW__react-dadata__suggestion-note",
  "react-dadata__suggestion-subtitle": "dadata-module-scss-module__kjrolW__react-dadata__suggestion-subtitle",
  "react-dadata__suggestion-subtitle-item": "dadata-module-scss-module__kjrolW__react-dadata__suggestion-subtitle-item",
  "react-dadata__suggestions": "dadata-module-scss-module__kjrolW__react-dadata__suggestions",
});
